module.exports = __webpack_public_path__ + "static/media/pulmonologyImage1@3x.73f8ace3.png";